<script lang="ts" setup>
import { useLoginStore } from './store/login';
import { watch } from 'vue';
import pinia from './store/store';
import { onShow, onLaunch, onHide } from '@dcloudio/uni-app';

import routingIntercept from '@/common/permission';
const loginStore = useLoginStore(pinia);
const navBarList = [
	{
		pagePath: 'pages/home/home',
		text: '首页',
		index: 0,
		iconPath: '/static/images/tabbar/home-icon1.png',
		selectedIconPath: '/static/images/tabbar/home-icon11.png'
	},
	{
		pagePath: 'pages/chat/chat',
		text: '消息',
		index: 1,
		iconPath: '/static/images/tabbar/home-icon2.png',
		selectedIconPath: '/static/images/tabbar/home-icon22.png'
	},
	{
		pagePath: 'pages/order/order',
		text: '订单',
		index: 2,
		iconPath: '/static/images/tabbar/order.png',
		selectedIconPath: '/static/images/tabbar/order-active.png'
	},
	{
		pagePath: 'pages/user/user',
		text: '我的',
		index: 3,
		iconPath: '/static/images/tabbar/home-icon3.png',
		selectedIconPath: '/static/images/tabbar/home-icon33.png'
	}
];
onLaunch(() => {
	// uni.hideTabBar({});
	// 对路由进行统一拦截，实现路由导航守卫 router.beforeEach 功能
	routingIntercept();
	if (uni.getStorageSync('userInfo')) {
		loginStore.setUserInfo(uni.getStorageSync('userInfo'));
	}
	loginStore.setMenu(uni.getStorageSync('userInfo'));
});

// watch(() => loginStore.isLogin, (data) => {
//     if (!data) {
//         uni.navigateTo({url: '/pages/login/login/login'})
//     }
// }, {immediate: true})

onShow(() => {
	console.log('App Show');
});

onHide(() => {
	console.log('App Hide');
});
</script>

<style lang="scss">
@import 'uview-ui/index.scss';
@import './common/app.css';
@import './static/style/thorui-extend.css';
@import './components/tuniao-ui/index.scss';
//@import './components/tuniao-ui/iconfont.css';
.container {
	// padding-bottom: 120rpx;
	box-sizing: border-box;
	height: 100%;
}

uni-page-body {
	height: 100%;
}

page {
	height: 100%;
}
</style>
